/**
 * Unit: pixels
 */
export const AD_LABEL_HEIGHT = 24;
